import { getApi } from "@beeldit/core/helpers/api";

function confirmAccount(token: string, onSuccess: (data: any) => void, onError: (error: any) => void) {
  const confirm = async () => {
    try {
      const response = await getApi().post("/confirm-account", { token });
      onSuccess(response.data);
    } catch (error) {
      console.error("Error confirming account:", error);
      onError(error);
    }
  };

  confirm();
}

export default confirmAccount;
